import { render, staticRenderFns } from "./FavoriteToggler.vue?vue&type=template&id=1ffac1b4&scoped=true&"
import script from "./FavoriteToggler.vue?vue&type=script&lang=js&"
export * from "./FavoriteToggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffac1b4",
  null
  
)

export default component.exports